
import HubWebinar from "@/models/hub/HubWebinar"
import setUpShaka from "@/composables/shaka-player/load-shaka"

import { computed, defineComponent, PropType, ref, Ref, watch } from "vue"
import { isIOS } from "@/services/deviceDetection"
export default defineComponent({
  props: {
    webinar: { type: Object as PropType<HubWebinar>, required: true },
    hovering: { type: Object as PropType<Ref<Boolean>>, required: true },
    shouldLoad: { type: Boolean, required: true, default: false }
  },
  setup(props) {
    const IS_IOS = isIOS(navigator.userAgent, navigator.maxTouchPoints)
    const hasMoments = computed(() => {
      if (!props.webinar.moments) return false
      return props.webinar.moments.length > 0
    })
    const hasSpeakers = computed(() => {
      if (!props.webinar.speakers) return false
      return props.webinar.speakers.length > 0
    })
    const isVideoLoaded = ref(false)
    const isLoading = ref(false)
    const video = ref<HTMLVideoElement>()
    const isPlaying = ref(false)
    let shakaSetUpObj = setUpShaka(video, ref(false), true)
    var watcher = watch(props.hovering, async (newVal, oldVal) => {
      if (!isVideoLoaded.value) {
        await loadShaka()
        return
      }
      if (newVal == true) await playVideo()
      else await pauseVideo()
    })

    const loadShaka: Function = async () => {
      if (!IS_IOS && props.webinar.trailer.video_urls.dash_url && !isLoading.value) {
        isLoading.value = true
        await shakaSetUpObj.loaddash(props.webinar.trailer.video_urls.dash_url).then(() => {
          isVideoLoaded.value = true
          if (props.hovering) playVideo()
        })
      }
    }
    const playVideo = async () => {
      video.value?.play().then(() => {
        if (!props.hovering) video.value?.pause()
        else isPlaying.value = true
      })
    }
    const pauseVideo = async () => {
      if (isPlaying.value) {
        video.value?.pause()
        isPlaying.value = false
      }
    }
    return { IS_IOS, hasMoments, hasSpeakers, video, shakaSetUpObj, watcher, isVideoLoaded, loadShaka, isLoading, isPlaying }
  },
  async mounted() {
    if (this.shouldLoad) await this.loadShaka()
  },
  async beforeUnmount() {
    if (this.isVideoLoaded) {
      await this.shakaSetUpObj.detachShakaPlayer()
      this.isVideoLoaded = false
      this.isLoading = false
    }
  }
})
